export default function outsideClick(elements, eventHandler) {

    // Handle the click and fire the event handler if needed
    var handleClick = function handleClick(e) {
        for (var target = e.target; target; target = target.parentNode) {
            var found = elements.indexOf(target) > -1;
            if (found) return;
        }

        if (document.body.getBoundingClientRect().width < 641) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
        }

        eventHandler(e);
    };

    // Remove the event listeners
    var off = function off() {
        document.removeEventListener('click', handleClick, {capture: true});
    };

    // If just one element is passed in instead of an array, convert it
    if (!elements.indexOf) {
        elements = [elements];
    }

    document.addEventListener('click', handleClick, {capture: true});

    return {
        off: off
    };
};



// WEBPACK FOOTER //
// ./utilities/outsideClick.js